import $axios from '@/axios-instance.js'

export const userSettingsService = {
  getCurrentUserSettings,
  saveCurrentUserSettings
}

function getCurrentUserSettings () {
  return $axios.get(`${process.env.ROOT_API}/user-settings`).then(response => {
    return response.data
  }).catch(error => {
    return Promise.reject(error)
  })
}

function saveCurrentUserSettings (userSettings) {
  return $axios.post(`${process.env.ROOT_API}/user-settings`, userSettings).then(response => {
    return response.data
  }).catch(error => {
    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/services/user-settings.service.js